import Vue from 'vue/dist/vue.esm';
import Vuex from 'vuex';
import TurbolinksAdapter from 'vue-turbolinks';
import VTooltip from 'v-tooltip'
import VueI18n from 'vue-i18n'
// Import Plugins
import MainPlugin from '../../javascripts/plugins/main';
import { ApiService } from '../../javascripts/services.js.erb';

// Import Store
import { globalStore } from './globalStore';

// Import Third Partie Libs
import VueTheMask from 'vue-the-mask';
import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect';
import ActionCableVue from 'actioncable-vue';
import VueQrcode from 'vue-qrcode';
import VueQuillEditor from 'vue-quill-editor'



// Import Indexes
import '../../images/index.js.erb';
import '../../javascripts/components/index.js.erb';

//Import translations
import { messages } from './i18n/commonMessages.js.erb';



Vue.use(Vuex)
Vue.use(TurbolinksAdapter)
Vue.use(MainPlugin);
Vue.use(VueQuillEditor, {
    placeholder: '',
    modules: {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }, 'bold', { 'color': [] }, { 'background': [] }],
            ['link'  ],
            ['clean']
        ],
        }
    });

// Register Third Parties Libs
Vue.use(VueTheMask)
Vue.use(VTooltip)
Vue.use(VueI18n)
Vue.component('vue-datetime', Datetime);
Vue.component('vue-multiselect', Multiselect);
Vue.component('vue-qrcode', VueQrcode);

Vue.use(ActionCableVue, {
    debug: true,
    debugLevel: 'error',
    connectionUrl: 'wss://plameet.com/cable',
    connectImmediately: true,
});

Vue.prototype.$apiService = ApiService

const store = new Vuex.Store(globalStore);

document.addEventListener('turbolinks:load', () => {
    const element = document.getElementById('appAdmin');
    const localeMetaElement = document.querySelector('meta[name="locale"]')
    const locale = !!localeMetaElement ? localeMetaElement.content : "en"
    if (element != null) {
        const i18n = new VueI18n({
            locale: locale,
            messages,
        })
        const app = new Vue({
            el: '#appAdmin',
            store: store,
            i18n
        });
        console.log('Loaded Vue');
    }
})
